import * as Config from "@/config";
import {RefObject} from "react";
import {DrmInformation} from "@/types/drmInformation";

export const controlNum = (data_id: number) => {
  return String(data_id).padStart(5, "0");
};

export const addDisplayNum = (faqs: any[]): any[] => {
  return faqs.map((faq, index) => {
    return {...faq, display_num: index + 1};
  });
};

export const paginateCurrentValues = (
  currentPage: number,
  pageSize: string,
  drmInformationList: DrmInformation[]
) => {
  const indexOfLastItem = (currentPage + 1) * Number(pageSize);
  const firstItemNum = indexOfLastItem - Number(pageSize);
  const lastItemNum =
    drmInformationList.length < indexOfLastItem
      ? drmInformationList.length
      : indexOfLastItem;
  const currentItems = drmInformationList.slice(
    firstItemNum,
    indexOfLastItem
  );

  return {firstItemNum, lastItemNum, currentItems};
};

export const inputAttributeOptionValue = (attributeOption: any) => {
  return createAttributeOptionValue(
    attributeOption.id,
    attributeOption.code,
    attributeOption.option
  );
};
// TODO: 値の持ち方検討→selectにはoption_idで持っておいてget/postの際にcode_valueで検索
export const createAttributeOptionValue = (
  attribute_option_id: any,
  attribute_code: any,
  attribute_value: any
) => {
  return (
    attribute_option_id +
    Config.SPLIT_CODE +
    attribute_code +
    Config.SPLIT_CODE +
    attribute_value
  );
};

export const inputAttributeToPostParam = (
  attributes: Array<any>,
  data: any,
  dataMap: Map<string, any> | undefined = undefined
): any => {
  const inputAttributes = {} as any;
  if (!data.attributes) return inputAttributes;
  for (const attribute of attributes) {
    const inputValue = data.attributes[attribute.id];
    if (!inputValue || inputValue.length === 0) continue;
    const dataAttributeValue = dataMap?.get(attribute.id) || undefined;
    if (Config.ATTRIBUTE_CODES.includes(attribute.attribute_kind_code)) {
      const values: any[] = [];
      if (Array.isArray(inputValue)) {
        for (const check of inputValue) {
          const [option_id, code, value] = check.split(Config.SPLIT_CODE);
          const setValue = {
            attribute_code: code,
            attribute_value: value,
          } as any;
          if (dataAttributeValue) {
            const existsData = existsDataAttributeValue(
              code,
              value,
              dataAttributeValue
            );
            if (existsData) setValue["id"] = existsData.id;
          }
          values.push(setValue);
        }
        inputAttributes[attribute.id] = values;
      }
      if (
        typeof inputValue === "string" &&
        inputValue.includes(Config.SPLIT_CODE)
      ) {
        const [option_id, code, value] = inputValue.split(Config.SPLIT_CODE);
        const setValue = {
          attribute_code: code,
          attribute_value: value,
        } as any;
        if (dataAttributeValue) {
          const existsData = existsDataAttributeValue(
            code,
            value,
            dataAttributeValue
          );
          if (existsData) setValue["id"] = existsData.id;
        }
        if (attribute.column_name === Config.ATTRIBUTE_COLUMN_NAME_INQUIRY_TYPE) {
          const option = attribute.attribute_options.find((o: any) => o.id == option_id)
          inputAttributes[option.attribute_id] = setValue;
        } else {
          inputAttributes[attribute.id] = setValue;
        }
      } else {
        inputAttributes[attribute.id] = {attribute_value: inputValue};
        if (dataAttributeValue) {
          inputAttributes[attribute.id]["id"] = dataAttributeValue.id;
        }
      }
    } else {
      inputAttributes[attribute.id] = {attribute_value: inputValue};
      if (dataAttributeValue) {
        inputAttributes[attribute.id]["id"] = dataAttributeValue.id;
      }
    }
  }
  return inputAttributes;
};

export const existsDataAttributeValue = (
  attribute_code: string,
  attribute_value: string,
  dataAttributeValue: any
): any => {
  if (Array.isArray(dataAttributeValue)) {
    for (const check of dataAttributeValue) {
      if (
        attribute_code === check.attribute_code &&
        attribute_value === check.attribute_value
      )
        return check;
    }
  } else {
    if (
      attribute_code === dataAttributeValue.attribute_code &&
      attribute_value === dataAttributeValue.attribute_value
    )
      return dataAttributeValue;
  }
  return undefined;
};

export const getNestedValue = (data: any): any => {
  if (typeof data === "object")
    return getNestedValue(data[Object.keys(data)[0]]);
  else return data;
};

/* ツリーのエリアデータから子エリアを探す */
export const getAreaById = (area: any, id: number): any | null => {
  if (area.id == id) {
    return area;
  }
  if (area.children) {
    for (const child of area.children) {
      const result = getAreaById(child, id);
      if (result) {
        return result;
      }
    }
  }
  return null;
};


/* react-hook-formのフォーム値から実際のvalueを取得する */
export const extractValue = (composed: string) => {
  const values = composed.split(Config.SPLIT_CODE);
  if (values.length == 3) {
    return values[2];
  } else {
    return composed;
  }
};

export const filesToPostParam = (files: any[]): any => {
  const toBase64 = (file: File) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  return Promise.all(
    files.map(async (item) => {
      const base64 = await toBase64(item.file);
      return {
        file_name: item.file.name,
        file_content: base64,
        file_attribute_code: Config.FILE_ATTRIBUTE_CODE_ATTACHED_FILE,
      };
    })
  );
};

export const isInvalidEmail = (value: string) => {
  // 基本的なメールアドレス形式チェック
  const regex =
    /^(?=.{1,254}$)(?=.{1,64}@)[0-9A-Za-z._%+-]+@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)+$/;

  // ピリオドが連続しているかチェック
  const hasDuplicateDots = /\.{2,}/.test(value);

  // @の直前にピリオドがあるかチェック
  const hasDotBeforeAt = /@/.test(value) && value.split('@')[0].endsWith('.');

  if (!regex.test(value) || hasDuplicateDots || hasDotBeforeAt) {
    return "メールアドレスが不正値です。";
  }
  return true;
};

export const maxSizeSum = (value: any) => {
  let totalSize = 0;
  for (let i = 0; i < value.length; i++) {
    totalSize += value[i]?.file?.size || 0;
  }
  return totalSize <= 1024 * 1024 * 10 || Config.MESSAGE_NO_E11;
};

export const smoothScroll = (
  scrollRef: RefObject<HTMLDivElement>,
  yOffset: number
) => {
  if (scrollRef.current) {
    // const yOffset = -70;
    const y = scrollRef.current.getBoundingClientRect().top + yOffset;
    window.scrollTo({top: y, behavior: "smooth"});
  }
};

export const addColorClass = (text: string, searchString: string) => {
  return text.toLowerCase().includes(searchString.toLowerCase())
    ? {color: "red"}
    : {};
};

export const getProjectCategoryId = (dataAttributeValues: any, attributes: any) => {
  let result;
  for (const key in dataAttributeValues) {
    attributes.forEach((a: any) => {
      if (a.column_name == Config.ATTRIBUTE_COLUMN_NAME_INQUIRY_TYPE) {
        const option = a.attribute_options?.find((o: any) => {
          return o.attribute_id == key
        })
        if (option) {
          result = option.project_category_id;
        }
      }
    })
  }
  return result;
}

export const filterDrmInformations = (
  drmInformations: DrmInformation[],
  checkTypeIds: string[],
  searchText: string,
  searchYear: string
) => {
  if (checkTypeIds.length > 0) {
    drmInformations = drmInformations.filter((drmPfInformation) =>
      checkTypeIds.includes(drmPfInformation.type.code)
    );
  }
  if (searchText.trim() !== "") {
    const texts = searchText.split(/[\s　]+/);
    drmInformations = drmInformations.filter((drmPfInformation) => {
      return texts.some((text) => {
        const lowerText = text.toLowerCase();
        return (
          drmPfInformation.title.toLowerCase().includes(lowerText) ||
          drmPfInformation.body.toLowerCase().includes(lowerText)
        );
      })
    });
  }
  if (searchYear.trim() !== "") {
    drmInformations = drmInformations.filter((drmPfInformation) => {
      return (
        new Date(drmPfInformation.release_date).getFullYear().toString() ==
        searchYear
      );
    });
  }
  return drmInformations;
};